import PhotosMissingSummaryJsonView from './PhotosMissingSummaryJsonView';

export default PhotosMissingSummaryJsonView;
